import React from 'react';
import { Popover, useTheme } from '@mui/material';
import TrackedObjectSelector from './TrackedObjectSelector';
import { AutoIsoPlayer } from '@/features/autoIso/types/AutoIsoModel';

interface TrackedObjectSelectorDialogProps {
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
  value?: any;
  setFixedCameraClip: () => void;
  selectTrackedObject: (ent: any, source?: string) => void;
  featuredPlayers?: AutoIsoPlayer[];
}

export const TrackedObjectSelectorDialog: React.FC<TrackedObjectSelectorDialogProps> = ({
  open,
  onClose,
  anchorEl,
  value,
  setFixedCameraClip,
  selectTrackedObject,
  featuredPlayers,
}) => {
  const theme = useTheme();

  const handleSelectTrackedObject = (ent: any, source?: string) => {
    selectTrackedObject(ent, source);
    // Close popover after selection
    onClose();
  };

  const handleSetFixedCameraClip = () => {
    setFixedCameraClip();
    // Close popover after selection
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: {
               backgroundColor: theme.palette.cx.bg.elevated,
               border: `1px solid ${theme.palette.cx.border.subtle}`,
            backgroundImage: 'none',
            width: anchorEl ? anchorEl.offsetWidth : 'auto',
            minWidth: '600px',
            maxWidth: '800px',
            mt: 0.5,
            borderRadius: 1,

          //  backgroundColor: 'rgba(255, 255, 255, 0.119)',
          //  backdropFilter: 'blur(10px)',
          //  WebkitBackdropFilter: 'blur(10px)', // For Safari
          //  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.9)',
          //  border: '1px solid rgba(255, 255, 255, 0.10)',
          },
        },
      }}
    >
      <TrackedObjectSelector
        sx={{
          maxHeight: '500px',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'flex-start',
          backgroundColor: 'transparent',
        }}
        value={value}
        setFixedCameraClip={handleSetFixedCameraClip}
        selectTrackedObject={handleSelectTrackedObject}
        featuredPlayers={featuredPlayers}

      />
    </Popover>
  );
};

export default TrackedObjectSelectorDialog;
